import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Row, Col, Button, Container } from "react-bootstrap";
import axios from "axios";
import { selectUser } from "../../features/userSlice";
import "./Dashboard.css";

const Dashboard = () => {
  const [menuOptions, setMenuOptions] = useState([]);
  const user = useSelector(selectUser);
  const emp_id = user?.emp_id;
  const token = user?.token;
  const navigate = useNavigate();

  useEffect(() => {
    if (token && emp_id) {
      const fetchMenuOptions = async () => {
        try {
          const menuResponse = await axios.post("/api/menu/getMobMenuUserData", { emp_id });

          const parentMenus = menuResponse.data.filter(menu => menu.parent_menu_id === 0);
          const childMenus = menuResponse.data.filter(menu => menu.parent_menu_id !== 0);

          const groupedMenuOptions = parentMenus.map(parent => ({
            ...parent,
            children: childMenus.filter(child => child.parent_menu_id === parent.menu_id),
          }));

          setMenuOptions(groupedMenuOptions);
        } catch (error) {
          console.error("Error fetching menu options:", error);
        }
      };

      fetchMenuOptions();
    } else {
      navigate("/login");
    }
  }, [token, emp_id, navigate]);

  const handleTileClick = (menuUrl) => {
    if (menuUrl) {
      navigate(menuUrl);
    } else {
      console.error("No URL assigned to this menu item.");
    }
  };

  return (
    <div className="dashboard-container">
      <Container fluid>
        <h1 className="dashboard-title">Welcome to Your CLMS</h1>

        {menuOptions.map((parentMenu, index) => (
          parentMenu.menu_url ? (
            <Row key={index} className="mb-2">
              <Col xs={6} sm={4} md={3} lg={2} className="mb-2">
                <Button
                  variant="outline-primary"
                  className="menu-tile-btn"
                  onClick={() => handleTileClick(parentMenu.menu_url)}
                >
                  {parentMenu.menu_name}
                </Button>
              </Col>
            </Row>
          ) : (
            <div key={index} className="menu-section">
              <h2 className="section-title">{parentMenu.menu_name}</h2>
              <Row>
                {parentMenu.children.map((childMenu, childIndex) => (
                  <Col key={childIndex} xs={6} sm={4} md={3} lg={2} className="mb-2">
                    <Button
                      variant="outline-primary"
                      className="menu-tile-btn"
                      onClick={() => handleTileClick(childMenu.menu_url)}
                    >
                      {childMenu.menu_name}
                    </Button>
                  </Col>
                ))}
              </Row>
            </div>
          )
        ))}
      </Container>
    </div>
  );
};

export default Dashboard;
